<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  @import './style/common.scss';

</style>



// WEBPACK FOOTER //
// src/App.vue